<app-digital-marketing-template-list></app-digital-marketing-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateMarketingTemplateModal()">
    Create Marketing Template
  </lib-button-primary>
</lib-button-input-portal>
